var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Collection, ComplexFactory } from '@syncfusion/ej2-base'; /*externalscript*/
/**   @private  */
let getGradientType = (obj) => {
    switch (obj.type) {
        case 'Linear':
            return LinearGradient;
        case 'Radial':
            return RadialGradient;
        default:
            return LinearGradient;
    }
};
/**
 * Layout Model module defines the styles and types to arrange objects in containers
 */
export class Thickness {
    constructor(left, right, top, bottom) {
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
    }
}
/**
 * Defines the space to be left between an object and its immediate parent
 */
export class Margin extends ChildProperty {
}
__decorate([
    Property(0)
], Margin.prototype, "left", void 0);
__decorate([
    Property(0)
], Margin.prototype, "right", void 0);
__decorate([
    Property(0)
], Margin.prototype, "top", void 0);
__decorate([
    Property(0)
], Margin.prototype, "bottom", void 0);
/**
 * Defines the different colors and the region of color transitions
 * ```html
 * <div id='diagram'></div>
 * ```
 * ```typescript
 * let stopscol: StopModel[] = [];
 * let stops1: StopModel = { color: 'white', offset: 0, opacity: 0.7 };
 * stopscol.push(stops1);
 * let stops2: StopModel = { color: 'red', offset: 0, opacity: 0.3 };
 * stopscol.push(stops2);
 * let gradient: RadialGradientModel = { cx: 50, cy: 50, fx: 50, fy: 50, stops: stopscol, type: 'Radial' };
 * let nodes: NodeModel[] = [{ id: 'node1', width: 100, height: 100,
 * style: { gradient: gradient }
 * }];
 * let diagram: Diagram = new Diagram({
 * ...
 *   nodes: nodes,
 * ...
 * });
 * diagram.appendTo('#diagram');
 * ```
 */
export class Stop extends ChildProperty {
    /**
     * @private
     * Returns the name of class Stop
     */
    getClassName() {
        return 'Stop';
    }
}
__decorate([
    Property('')
], Stop.prototype, "color", void 0);
__decorate([
    Property(0)
], Stop.prototype, "offset", void 0);
__decorate([
    Property(1)
], Stop.prototype, "opacity", void 0);
/**
 * Paints the node with a smooth transition from one color to another color
 */
export class Gradient extends ChildProperty {
}
__decorate([
    Collection([], Stop)
], Gradient.prototype, "stops", void 0);
__decorate([
    Property('None')
], Gradient.prototype, "type", void 0);
__decorate([
    Property('')
], Gradient.prototype, "id", void 0);
/**
 * Defines the linear gradient of styles
 * ```html
 * <div id='diagram'></div>
 * ```
 * ```typescript
 * let stopscol: StopModel[] = [];
 * let stops1: StopModel = { color: 'white', offset: 0, opacity: 0.7 };
 * stopscol.push(stops1);
 * let stops2: StopModel = { color: 'red', offset: 0, opacity: 0.3 };
 * stopscol.push(stops2);
 * let gradient: LinearGradientModel = { x1: 0, x2: 50, y1: 0, y2: 50, stops: stopscol, type: 'Linear' };
 * let nodes: NodeModel[] = [{ id: 'node1', width: 100, height: 100,
 * style: { gradient: gradient }
 * }];
 * let diagram: Diagram = new Diagram({
 * ...
 *   nodes: nodes,
 * ...
 * });
 * diagram.appendTo('#diagram');
 * ```
 */
/**
 * Paints the node with linear color transitions
 */
export class LinearGradient extends Gradient {
}
__decorate([
    Property(0)
], LinearGradient.prototype, "x1", void 0);
__decorate([
    Property(0)
], LinearGradient.prototype, "x2", void 0);
__decorate([
    Property(0)
], LinearGradient.prototype, "y1", void 0);
__decorate([
    Property(0)
], LinearGradient.prototype, "y2", void 0);
/**
 * A focal point defines the beginning of the gradient, and a circle defines the end point of the gradient
 * ```html
 * <div id='diagram'></div>
 * ```
 * ```typescript
 * let stopscol: StopModel[] = [];
 * let stops1: StopModel = { color: 'white', offset: 0, opacity: 0.7 };
 * stopscol.push(stops1);
 * let stops2: StopModel = { color: 'red', offset: 0, opacity: 0.3 };
 * stopscol.push(stops2);
 * let gradient: RadialGradientModel = { cx: 50, cy: 50, fx: 50, fy: 50, stops: stopscol, type: 'Radial' };
 * let nodes: NodeModel[] = [{ id: 'node1', width: 100, height: 100,
 * style: { gradient: gradient }
 * }];
 * let diagram: Diagram = new Diagram({
 * ...
 *   nodes: nodes,
 * ...
 * });
 * diagram.appendTo('#diagram');
 * ```
 */
export class RadialGradient extends Gradient {
}
__decorate([
    Property(0)
], RadialGradient.prototype, "cx", void 0);
__decorate([
    Property(0)
], RadialGradient.prototype, "cy", void 0);
__decorate([
    Property(0)
], RadialGradient.prototype, "fx", void 0);
__decorate([
    Property(0)
], RadialGradient.prototype, "fy", void 0);
__decorate([
    Property(50)
], RadialGradient.prototype, "r", void 0);
/**
 * Defines the style of shape/path
 */
export class ShapeStyle extends ChildProperty {
}
__decorate([
    Property('white')
], ShapeStyle.prototype, "fill", void 0);
__decorate([
    Property('black')
], ShapeStyle.prototype, "strokeColor", void 0);
__decorate([
    Property('')
], ShapeStyle.prototype, "strokeDashArray", void 0);
__decorate([
    Property(1)
], ShapeStyle.prototype, "strokeWidth", void 0);
__decorate([
    Property(1)
], ShapeStyle.prototype, "opacity", void 0);
__decorate([
    ComplexFactory(getGradientType)
], ShapeStyle.prototype, "gradient", void 0);
/**
 * Defines the stroke style of a path
 */
export class StrokeStyle extends ShapeStyle {
}
__decorate([
    Property('transparent')
], StrokeStyle.prototype, "fill", void 0);
/**
 * Defines the appearance of text
 * ```html
 * <div id='diagram'></div>
 * ```
 * ```typescript
 * let style: TextStyleModel = { strokeColor: 'black', opacity: 0.5, strokeWidth: 1 };
 * let node: NodeModel;
 * node = {
 * ...
 * id: 'node', width: 100, height: 100, offsetX: 100, offsetY: 100,
 * annotations : [{
 * content: 'text', style: style }];
 * ...
 * };
 * let diagram: Diagram = new Diagram({
 * ...
 *   nodes: [node],
 * ...
 * });
 * diagram.appendTo('#diagram');
 * ```
 */
export class TextStyle extends ShapeStyle {
}
__decorate([
    Property('black')
], TextStyle.prototype, "color", void 0);
__decorate([
    Property('Arial')
], TextStyle.prototype, "fontFamily", void 0);
__decorate([
    Property(12)
], TextStyle.prototype, "fontSize", void 0);
__decorate([
    Property(false)
], TextStyle.prototype, "italic", void 0);
__decorate([
    Property(false)
], TextStyle.prototype, "bold", void 0);
__decorate([
    Property('CollapseSpace')
], TextStyle.prototype, "whiteSpace", void 0);
__decorate([
    Property('WrapWithOverflow')
], TextStyle.prototype, "textWrapping", void 0);
__decorate([
    Property('Center')
], TextStyle.prototype, "textAlign", void 0);
__decorate([
    Property('None')
], TextStyle.prototype, "textDecoration", void 0);
__decorate([
    Property('Wrap')
], TextStyle.prototype, "textOverflow", void 0);
__decorate([
    Property('transparent')
], TextStyle.prototype, "fill", void 0);
